/**
 * @fileoverview Agent definition for chapter-planner-composite-v1.
 *
 * Composite agent that orchestrates the two-step chapter planning flow:
 * 1. chapter-planner-v2 — generates a chapter skeleton with a key-events seed
 * 2. key-events-expander-v2 — expands the seed into a full beat sheet
 *
 * The composite preserves the original userMessage (author sketch) and threads
 * it through to the expander as authoritative guidance.
 *
 * @category narrative.chapters.planning
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
export const definition: AppAgentDefinition = {
  id: 'chapter-planner-composite-v1',
  kind: 'composite',
  name: 'Chapter Planner (Composite)',
  description:
    'Plans a chapter in two steps: skeleton generation (chapter-planner-v2) followed by key-events expansion from seed (key-events-expander-v2). Preserves the original author sketch across both steps.',
  category: 'structure',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'narrative.chapters.planning',
    usedBy: [
      'primitives/use-chapter-planner-composite-v1.ts',
    ],
    composedOf: [
      'chapter-planner-v2',
      'key-events-expander-v2',
    ],
    relatedAgents: [
      'next-chapter-suggester-v2',
      'chapter-architect-v2',
    ],
  },
};
